export const PageHead = ({ eyebrow, title, sub, children }) => (
  <section className="relative grain overflow-hidden bg-[#1E293B] text-white">
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-amber-300">{eyebrow}</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-3 max-w-3xl">{title}</h1>
      {sub && <p className="text-slate-300 mt-3 max-w-2xl text-base md:text-lg">{sub}</p>}
      {children}
    </div>
  </section>
);
